import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f3d980a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "passenger-details__loading"
}
const _hoisted_2 = {
  key: 2,
  class: "passenger-details"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_PassengerList = _resolveComponent("PassengerList")!
  const _component_LeadPassenger = _resolveComponent("LeadPassenger")!
  const _component_AgentCustomer = _resolveComponent("AgentCustomer")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BaseSpinner, { size: 50 })
      ]))
    : (_ctx.error)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 1,
          type: "danger",
          message: _ctx.error
        }, null, 8, ["message"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_PassengerList),
          _createVNode(_component_LeadPassenger),
          (_ctx.isAgent === true)
            ? (_openBlock(), _createBlock(_component_AgentCustomer, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
}